import { Injectable } from '@angular/core';
import { Route, PreloadingStrategy } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { OnDemandPreloadOptions } from './on-demand-preload-options.class';
import { OnDemandPreloadService } from './on-demand-preload.service';

@Injectable({ providedIn: 'root', deps: [OnDemandPreloadService] })
export class OnDemandPreloadStrategy implements PreloadingStrategy {
	private readonly preloadOnDemand$: Observable<OnDemandPreloadOptions>;

	constructor(private readonly preloadOnDemandService: OnDemandPreloadService) {
		this.preloadOnDemand$ = this.preloadOnDemandService.state;
	}

	preload(route: Route, load: () => Observable<any>): Observable<any> {
		return this.preloadOnDemand$.pipe(
			mergeMap((preloadOptions) => {
				const shouldPreload = this.preloadCheck(route, preloadOptions);

				return shouldPreload ? load() : EMPTY;
			})
		);
	}

	// tslint:disable-next-line:prefer-function-over-method
	private preloadCheck(
		route: Route,
		preloadOptions: OnDemandPreloadOptions
	): boolean {
		// Only load the modules bundle lazily if the route matches the module
		// This loading will block the ui until the script loads (in this case 1 feature module script),
		// but this lowers the overall number of scripts
		// loaded navigating to each feature module using Angular's built in PreLoadAllModules strategy. We DO NOT want to lazily load all modules
		// on every navigation to a feature, only the one required. Angular has nothing like this out of the box.
		return (
			route.data &&
			route.data.preload &&
			[route.path, '*'].includes(preloadOptions.routePath) &&
			preloadOptions.preload
		);
	}
}
